import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import { useSelector, useDispatch } from 'react-redux'
import InputArea from './components/InputArea'
import ChatWindow from './components/ChatWindow'
import LightProfileModal from 'srcReact/components/common2/LightProfileModal'
import EmptyConversation from './components/EmptyConversation'
import { messengerActions } from 'srcReact/MessengerPage/actions'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import useScrollToElement from 'srcReact/helpers/hooks/useScrollToElement'

const MessengerDesktop = ({ isMobile, isDesktop, isNative, isExpanded, setIsExpanded }) => {
  const { t } = useTranslation()
  const { targetRefs, scrollToTarget } = useScrollToElement()

  const dispatch = useDispatch()
  const {
    messenger: { sidebarScreenType, openedConversation, conversation }
  } = useSelector((state) => state)
  const [focusedMode, setFocusedMode] = useState(false)

  const handleToggler = () => {
    if (isExpanded && sidebarScreenType === 'create') {
      dispatch(messengerActions.setSideBarScreenType('search'))
    }
    setIsExpanded(!isExpanded)
  }
  const showUserLightModal = (modalUser) => {
    const lp = new LightProfileProto()
    lp.userId = modalUser.id || modalUser.user_id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <div className={styles.messangerWrapper}>
      <aside
        className={`${styles.sidebarContainer} ${!isExpanded && styles.sidebarContainerCollapsed} ${
          !isMobile && isExpanded && sidebarScreenType === 'create' && styles.sidebarContainerCreateConv
        }`}>
        <Sidebar
          isExpanded={isExpanded}
          onToggle={handleToggler}
          showUserLightModal={showUserLightModal}
          isMobile={isMobile}
          isDesktop={isDesktop}
        />
      </aside>
      <div
        className={`${styles.mainContainer} ${!isExpanded && styles.mainContainerWithCollapsed} ${
          !isMobile && isExpanded && sidebarScreenType === 'create' && styles.mainContainerWithCreateConv
        }`}>
        {conversation.list.length >= 1 && (
          <React.Fragment>
            <header className={styles.headerContainer}>
              <Header />
            </header>

            <div className={`${styles.chatWindow}`}>
              <ChatWindow
                isMobile={isMobile}
                isDesktop={isDesktop}
                isNative={isNative}
                targetRefs={targetRefs}
                scrollToTarget={scrollToTarget}
              />
            </div>
            {openedConversation ? (
              openedConversation.conversation.isLeftByUser === 1 ||
              openedConversation.conversation.hasBeenRemoved === 1 ? (
                <div className={`${styles.inputAreaContainer} ${styles.inputAreaContainerEmpty}`}></div>
              ) : (
                <div className={styles.inputAreaContainer}>
                  <InputArea
                    showEmoji={true}
                    showFileUpload={true}
                    scrollToTarget={scrollToTarget}
                    focusedMode={focusedMode}
                    setFocusedMode={setFocusedMode}
                  />
                </div>
              )
            ) : null}
          </React.Fragment>
        )}
        {isDesktop && !conversation.loading && conversation.loaded && conversation.list.length === 0 && (
          <EmptyConversation />
        )}
      </div>
    </div>
  )
}

export default MessengerDesktop
